'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

import { buttonVariants } from '../components/ui/button';

import Logo from '../components/Logo';

export default function NavBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-white'
      }`}
    >
      <div className="custom-container flex items-center justify-between py-4">
        <div className="w-48">
          <Logo />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-1">
          <a
            href="#why-matters"
            className="px-4 py-2 text-gray-600 hover:text-woodland-700 rounded-lg hover:bg-woodland-50 transition-colors font-medium text-sm"
          >
            Why It Matters
          </a>
          <a
            href="#what-sets-us-apart"
            className="px-4 py-2 text-gray-600 hover:text-woodland-700 rounded-lg hover:bg-woodland-50 transition-colors font-medium text-sm"
          >
            What Sets Us Apart
          </a>
          <a
            href="#the-story"
            className="px-4 py-2 text-gray-600 hover:text-woodland-700 rounded-lg hover:bg-woodland-50 transition-colors font-medium text-sm"
          >
            The Story
          </a>
        </div>

        {/* Desktop Contact Button */}
        <div className="hidden md:block">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-woodland-700 text-white font-semibold py-2.5 px-5 rounded-lg text-sm shadow-sm shadow-woodland-700/20 hover:bg-woodland-800 hover:shadow-md hover:shadow-woodland-700/25 transition-all duration-200"
          >
            Let&apos;s Connect
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <X className="w-6 h-6 text-gray-700" />
          ) : (
            <Menu className="w-6 h-6 text-gray-700" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileMenuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-6 pt-2 bg-white border-t border-gray-100 space-y-1">
          <a
            href="#why-matters"
            className="block py-3 px-4 text-gray-600 hover:text-woodland-700 hover:bg-woodland-50 rounded-lg transition-colors font-medium"
            onClick={() => setMobileMenuOpen(false)}
          >
            Why It Matters
          </a>
          <a
            href="#what-sets-us-apart"
            className="block py-3 px-4 text-gray-600 hover:text-woodland-700 hover:bg-woodland-50 rounded-lg transition-colors font-medium"
            onClick={() => setMobileMenuOpen(false)}
          >
            What Sets Us Apart
          </a>
          <a
            href="#the-story"
            className="block py-3 px-4 text-gray-600 hover:text-woodland-700 hover:bg-woodland-50 rounded-lg transition-colors font-medium"
            onClick={() => setMobileMenuOpen(false)}
          >
            The Story
          </a>
          <div className="pt-2">
            <a
              href="#contact"
              className="block text-center py-3 px-4 bg-woodland-700 text-white font-semibold rounded-lg hover:bg-woodland-800 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Let&apos;s Connect
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
